// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   OPERATIONAL THEME CSS
   For: Risk Management, Agents, Operational Apps
   ============================================================================ */

/* Import Google Fonts */

/* ============================================================================
   CSS CUSTOM PROPERTIES (Variables)
   ============================================================================ */

:root {
  /* ===== BRAND COLORS ===== */
  --brand-navy: #162349;
  --brand-navy-light: #2a4a7c;
  --brand-light-blue: #BDD8E5;
  --brand-light-blue-lighter: #D4E7F0;
  --brand-gray: #F4F4F4;
  --brand-green: #92A372;
  
  /* ===== PRIMARY COLORS (Operational Context) ===== */
  --primary: var(--brand-navy);
  --primary-accent: var(--brand-green);
  --sidebar-bg-start: var(--brand-navy);
  --sidebar-bg-end: var(--brand-navy-light);
  --sidebar-text: #ffffff;
  
  /* ===== BACKGROUNDS ===== */
  --bg-primary: #ffffff;
  --bg-secondary: #f0f2f5;
  --bg-tertiary: #fafafa;
  --bg-hover: #e6f7ff;
  --bg-active-tab: #ffffff;
  --bg-inactive-tab: rgba(255, 255, 255, 0.3);
  --bg-surface: #ffffff;
  
  /* ===== TEXT COLORS ===== */
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-tertiary: #8c8c8c;
  --text-hint: #999999;
  --text-white: #ffffff;
  --text-on-primary: #ffffff;
  
  /* ===== SEMANTIC COLORS ===== */
  --success: #52c41a;
  --error: #f5222d;
  --warning: #faad14;
  --info: #1890ff;
  
  /* ===== BORDERS & DIVIDERS ===== */
  --border-light: #f0f0f0;
  --border-medium: #dddddd;
  --border-dark: #cccccc;
  --border-primary: var(--brand-navy);
  
  /* ===== CHART COLORS (Blue Variations) ===== */
  --chart-primary: #2196F3;
  --chart-secondary: #64B5F6;
  --chart-tertiary: #90CAF9;
  --chart-quaternary: #BBDEFB;
  
  /* ===== WORKFLOW NODE COLORS (Keep existing palette) ===== */
  --node-start: #4CAF50;
  --node-ingestion: #2196F3;
  --node-business-rules: #9C27B0;
  --node-processing: #FF5722;
  --node-decision: #795548;
  --node-human-review: #607D8B;
  --node-output: #E91E63;
  --node-outbound: #00BCD4;
  --node-abort: #F44336;
  --node-completion: #4CAF50;
  --node-mcp: #FF7043;
  
  /* ===== ANNOTATION COLORS (Keep existing rainbow palette) ===== */
  --annotation-1: #FFEB3B;
  --annotation-2: #66FF00;
  --annotation-3: #FF9800;
  --annotation-4: #2196F3;
  --annotation-5: #F44336;
  --annotation-6: #8E44AD;
  --annotation-7: #795548;
  --annotation-8: #009688;
  --annotation-9: #FF5722;
  --annotation-10: #607D8B;
  --annotation-11: #E91E63;
  --annotation-12: #3F51B5;
  --annotation-13: #CDDC39;
  --annotation-14: #FFC107;
  --annotation-15: #00BCD4;
  --annotation-16: #9C27B0;
  
  /* ===== SHADOWS ===== */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.15);
  
  /* ===== TYPOGRAPHY ===== */
  --font-header: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  
  /* Font Sizes (QHD @ 125% scaling) */
  --font-size-base: 16px;
  --font-size-header-title: 22px;
  --font-size-header-user: 14px;
  --font-size-tab-title: 20px;
  --font-size-tile-name: 15px;
  --font-size-tile-description: 13px;
  --font-size-icon-label: 13px;
  --font-size-login-title: 20px;
  --font-size-input-label: 13px;
  --font-size-button: 14px;
  --font-size-section-header: 12px;
  --font-size-sidebar-nav: 16px;
  
  /* Font Weights */
  --font-weight-light: 300;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  
  /* ===== SPACING ===== */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-xxl: 48px;
  
  /* ===== BORDER RADIUS ===== */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  
  /* ===== Z-INDEX ===== */
  --z-sidebar: 10;
  --z-header: 100;
  --z-modal: 1000;
  --z-tooltip: 1100;
}

/* ============================================================================
   BASE STYLES
   ============================================================================ */

html {
  font-size: var(--font-size-base);
}

body {
  font-family: var(--font-body);
  color: var(--text-primary);
  background-color: var(--bg-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ============================================================================
   TYPOGRAPHY
   ============================================================================ */

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-header);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin: 0;
}

/* ============================================================================
   SIDEBAR GRADIENT
   ============================================================================ */

.sidebar-gradient {
  background: linear-gradient(180deg, var(--sidebar-bg-start) 0%, var(--sidebar-bg-end) 100%);
}

/* ============================================================================
   ANT DESIGN COMPONENT OVERRIDES
   ============================================================================ */

/* Buttons - Default Primary (Navy Blue) */
.ant-btn-primary {
  background-color: var(--brand-navy);
  border-color: var(--brand-navy);
  color: var(--text-white);
}

.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background-color: #1a2d5a;
  border-color: #1a2d5a;
  color: var(--text-white);
}

/* Action Buttons (Green - for primary actions like Submit, Save, Confirm) */
.action-button,
.ant-btn.action-button {
  background-color: var(--primary-accent) !important;
  border-color: var(--primary-accent) !important;
  color: var(--text-white) !important;
  font-family: var(--font-body) !important;
  font-weight: var(--font-weight-semibold) !important;
}

.action-button:hover,
.action-button:focus,
.ant-btn.action-button:hover,
.ant-btn.action-button:focus {
  background-color: #7a8f5d !important;
  border-color: #7a8f5d !important;
  color: var(--text-white) !important;
}

.action-button:active,
.ant-btn.action-button:active {
  background-color: #6a7f4d !important;
  border-color: #6a7f4d !important;
}

/* Regular Buttons (Navy Blue - for navigation, secondary actions) */
.regular-button,
.ant-btn.regular-button {
  background-color: var(--brand-navy) !important;
  border-color: var(--brand-navy) !important;
  color: var(--text-white) !important;
  font-family: var(--font-body) !important;
  font-weight: var(--font-weight-semibold) !important;
}

.regular-button:hover,
.regular-button:focus,
.ant-btn.regular-button:hover,
.ant-btn.regular-button:focus {
  background-color: #1a2d5a !important;
  border-color: #1a2d5a !important;
  color: var(--text-white) !important;
}

.regular-button:active,
.ant-btn.regular-button:active {
  background-color: #0f1a35 !important;
  border-color: #0f1a35 !important;
}

/* Inputs */
.ant-input:focus,
.ant-input-focused {
  border-color: var(--primary-accent) !important;
  box-shadow: 0 0 0 2px rgba(146, 163, 114, 0.2) !important;
}

/* Select */
.ant-select-focused .ant-select-selector,
.ant-select-selector:focus,
.ant-select-selector:active,
.ant-select-open .ant-select-selector {
  border-color: var(--primary-accent) !important;
  box-shadow: 0 0 0 2px rgba(146, 163, 114, 0.2) !important;
}

/* Radio */
.ant-radio-checked .ant-radio-inner {
  border-color: var(--primary-accent);
  background-color: var(--primary-accent);
}

.ant-radio:hover .ant-radio-inner {
  border-color: var(--primary-accent);
}

/* Checkbox */
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--primary-accent);
  border-color: var(--primary-accent);
}

.ant-checkbox:hover .ant-checkbox-inner {
  border-color: var(--primary-accent);
}

/* Progress */
.ant-progress-bg {
  background-color: var(--primary-accent) !important;
}

.ant-progress-success-bg {
  background-color: var(--success) !important;
}

.ant-progress-text {
  color: var(--primary-accent) !important;
}

/* Spin/Loading */
.ant-spin-dot-item {
  background-color: var(--primary-accent);
}

/* Tabs */
.ant-tabs-tab:not(.ant-tabs-tab-active) {
  background-color: var(--bg-inactive-tab);
}

.ant-tabs-tab.ant-tabs-tab-active {
  background-color: var(--bg-active-tab);
}

/* Table */
.ant-table-thead > tr > th {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

.ant-table-tbody > tr:hover > td {
  background-color: var(--bg-hover) !important;
}

/* Table Scrollbar */
.ant-table-tbody {
  scrollbar-width: thin;
  scrollbar-color: var(--primary-accent) var(--border-light);
}

.ant-table-tbody::-webkit-scrollbar {
  width: 6px;
}

.ant-table-tbody::-webkit-scrollbar-track {
  background: var(--border-light);
}

.ant-table-tbody::-webkit-scrollbar-thumb {
  background: var(--primary-accent);
  border-radius: 3px;
}

.ant-table-tbody::-webkit-scrollbar-thumb:hover {
  background: #7a8f5d;
}

/* Modal */
.ant-modal-header {
  border-bottom: 1px solid var(--border-light);
}

.ant-modal-title {
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

/* Card */
.ant-card-head {
  border-bottom: 1px solid var(--border-light);
}

.ant-card-head-title {
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

/* Tag */
.ant-tag {
  border-radius: var(--radius-sm);
}

/* Alert */
.ant-alert-info {
  border: 1px solid #d6f7ff;
  background-color: #f0f8ff;
}

.ant-alert-info .ant-alert-icon {
  color: var(--info);
}

/* Tooltip */
.ant-tooltip-inner {
  background-color: rgba(0, 0, 0, 0.85);
}

.ant-tooltip-arrow-content {
  background-color: rgba(0, 0, 0, 0.85);
}

/* Upload */
.ant-upload-drag .ant-upload-drag-icon {
  margin-bottom: var(--spacing-md);
}

.ant-upload-drag .ant-upload-text {
  font-size: var(--font-size-sidebar-nav);
  color: var(--text-secondary);
}

.ant-upload-drag .ant-upload-hint {
  color: var(--text-hint);
}

/* Steps */
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #d4e7f0 !important;
  border-color: var(--brand-navy) !important;
}

.ant-steps-item-finish .ant-steps-icon {
  color: var(--brand-navy) !important;
}

.ant-steps-item-process .ant-steps-item-icon {
  background-color: var(--brand-navy) !important;
  border-color: var(--brand-navy) !important;
}

.ant-steps-item-process .ant-steps-icon {
  color: white !important;
}

.ant-steps-item-finish .ant-steps-item-tail::after {
  background-color: var(--brand-navy) !important;
}

.ant-steps-item-title {
  font-size: var(--font-size-sidebar-nav) !important;
  font-weight: var(--font-weight-semibold) !important;
}

/* ============================================================================
   CUSTOM COMPONENT STYLES
   ============================================================================ */

/* Header */
.operational-header {
  background: var(--brand-navy);
  color: var(--text-white);
  padding: 8px 24px 0 24px;
  height: auto;
}

.header-title {
  font-family: var(--font-header);
  font-size: var(--font-size-header-title);
  font-weight: var(--font-weight-bold);
  color: var(--text-white);
}

.header-user {
  font-family: var(--font-header);
  font-size: var(--font-size-header-user);
  font-weight: var(--font-weight-medium);
  color: var(--text-white);
}

/* Tabs */
.tab-title {
  font-family: var(--font-body);
  font-size: var(--font-size-tab-title);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

/* Sidebar */
.sidebar-nav-item {
  font-family: var(--font-body);
  font-size: var(--font-size-sidebar-nav);
  font-weight: var(--font-weight-medium);
  color: var(--sidebar-text);
}

/* User Avatar */
.user-avatar {
  background-color: var(--bg-primary);
  color: var(--brand-navy);
  border: 2px solid var(--bg-primary);
}

/* Table Row Styles */
.table-row-even {
  background-color: var(--bg-tertiary);
}

.table-row-odd {
  background-color: var(--bg-primary);
}

.table-row-even:hover,
.table-row-odd:hover {
  background-color: var(--bg-hover) !important;
}

/* Chat Message Styles */
.chat-message-user {
  background-color: var(--brand-navy);
  color: var(--text-white);
}

.chat-message-assistant {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-light);
}

.chat-avatar {
  background-color: var(--brand-navy);
}

/* Button Styles */
.button-primary {
  background-color: var(--primary-accent);
  border-color: var(--primary-accent);
  color: var(--text-white);
  font-family: var(--font-body);
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-semibold);
}

.button-primary:hover {
  background-color: #7a8f5d;
  border-color: #7a8f5d;
}

/* Section Headers */
.section-header {
  font-family: var(--font-body);
  font-size: var(--font-size-section-header);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-primary);
}

/* Tile/Card Styles */
.tile-name {
  font-family: var(--font-body);
  font-size: var(--font-size-tile-name);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.tile-description {
  font-family: var(--font-body);
  font-size: var(--font-size-tile-description);
  font-weight: var(--font-weight-normal);
  color: var(--text-secondary);
}

/* Icon Label */
.icon-label {
  font-family: var(--font-body);
  font-size: var(--font-size-icon-label);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

/* Login Styles */
.login-title {
  font-family: var(--font-header);
  font-size: var(--font-size-login-title);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

.input-label {
  font-family: var(--font-body);
  font-size: var(--font-size-input-label);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}



/* ============================================================================
   STEPS COMPONENT OVERRIDES (Brand Navy)
   ============================================================================ */

/* Finished step icon (blue dot) */
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #162349 !important;
  border-color: #162349 !important;
}

/* Finished step icon inner dot */
.ant-steps-item-finish .ant-steps-icon-dot {
  background: #162349 !important;
}

/* Current/in-progress step icon */
.ant-steps-item-process .ant-steps-item-icon {
  background-color: #162349 !important;
  border-color: #162349 !important;
}

/* Current step icon inner dot */
.ant-steps-item-process .ant-steps-icon-dot {
  background: #162349 !important;
}

/* Connecting line after finished steps */
.ant-steps-item-finish .ant-steps-item-tail::after {
  background-color: #162349 !important;
}

/* The vertical line on the left */
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: #162349 !important;
}


/* ============================================================================
   UTILITY CLASSES
   ============================================================================ */

.text-primary { color: var(--text-primary); }
.text-secondary { color: var(--text-secondary); }
.text-tertiary { color: var(--text-tertiary); }
.text-white { color: var(--text-white); }

.bg-primary { background-color: var(--bg-primary); }
.bg-secondary { background-color: var(--bg-secondary); }
.bg-accent { background-color: var(--primary-accent); }

.border-primary { border-color: var(--border-primary); }
.border-light { border-color: var(--border-light); }

/* Spacing utilities */
.p-xs { padding: var(--spacing-xs); }
.p-sm { padding: var(--spacing-sm); }
.p-md { padding: var(--spacing-md); }
.p-lg { padding: var(--spacing-lg); }

.m-xs { margin: var(--spacing-xs); }
.m-sm { margin: var(--spacing-sm); }
.m-md { margin: var(--spacing-md); }
.m-lg { margin: var(--spacing-lg); }`, "",{"version":3,"sources":["webpack://./src/styles/operational-theme.css"],"names":[],"mappings":"AAAA;;;iFAGiF;;AAEjF,wBAAwB;;AAIxB;;iFAEiF;;AAEjF;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;;EAEtB,qDAAqD;EACrD,4BAA4B;EAC5B,oCAAoC;EACpC,qCAAqC;EACrC,yCAAyC;EACzC,uBAAuB;;EAEvB,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,qBAAqB;;EAErB,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;;EAE1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,mCAAmC;EACnC,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,mCAAmC;;EAEnC,+CAA+C;EAC/C,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;;EAE3B,6DAA6D;EAC7D,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;;EAEnB,kEAAkE;EAClE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,wBAAwB;EACxB,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;;EAE1C,2BAA2B;EAC3B,uEAAuE;EACvE,mEAAmE;;EAEnE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;;EAE7B,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;;EAE5B,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;;iFAEiF;;AAEjF;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;iFAEiF;;AAEjF;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;iFAEiF;;AAEjF;EACE,2FAA2F;AAC7F;;AAEA;;iFAEiF;;AAEjF,0CAA0C;AAC1C;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,4EAA4E;AAC5E;;EAEE,kDAAkD;EAClD,8CAA8C;EAC9C,mCAAmC;EACnC,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,oEAAoE;AACpE;;EAEE,8CAA8C;EAC9C,0CAA0C;EAC1C,mCAAmC;EACnC,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,WAAW;AACX;;EAEE,8CAA8C;EAC9C,yDAAyD;AAC3D;;AAEA,WAAW;AACX;;;;EAIE,8CAA8C;EAC9C,yDAAyD;AAC3D;;AAEA,UAAU;AACV;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,SAAS;AACT;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,QAAQ;AACR;EACE,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;EAClD,mDAAmD;AACrD;;AAEA;;iFAEiF;;AAEjF,WAAW;AACX;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,uCAAuC;EACvC,mCAAmC;EACnC,wBAAwB;EACxB,6BAA6B;EAC7B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;AAC5B;;;;AAIA;;iFAEiF;;AAEjF,kCAAkC;AAClC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;AACtC;;;AAGA;;iFAEiF;;AAEjF,gBAAgB,0BAA0B,EAAE;AAC5C,kBAAkB,4BAA4B,EAAE;AAChD,iBAAiB,2BAA2B,EAAE;AAC9C,cAAc,wBAAwB,EAAE;;AAExC,cAAc,mCAAmC,EAAE;AACnD,gBAAgB,qCAAqC,EAAE;AACvD,aAAa,uCAAuC,EAAE;;AAEtD,kBAAkB,mCAAmC,EAAE;AACvD,gBAAgB,iCAAiC,EAAE;;AAEnD,sBAAsB;AACtB,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;;AAEpC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE","sourcesContent":["/* ============================================================================\n   OPERATIONAL THEME CSS\n   For: Risk Management, Agents, Operational Apps\n   ============================================================================ */\n\n/* Import Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n/* ============================================================================\n   CSS CUSTOM PROPERTIES (Variables)\n   ============================================================================ */\n\n:root {\n  /* ===== BRAND COLORS ===== */\n  --brand-navy: #162349;\n  --brand-navy-light: #2a4a7c;\n  --brand-light-blue: #BDD8E5;\n  --brand-light-blue-lighter: #D4E7F0;\n  --brand-gray: #F4F4F4;\n  --brand-green: #92A372;\n  \n  /* ===== PRIMARY COLORS (Operational Context) ===== */\n  --primary: var(--brand-navy);\n  --primary-accent: var(--brand-green);\n  --sidebar-bg-start: var(--brand-navy);\n  --sidebar-bg-end: var(--brand-navy-light);\n  --sidebar-text: #ffffff;\n  \n  /* ===== BACKGROUNDS ===== */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f0f2f5;\n  --bg-tertiary: #fafafa;\n  --bg-hover: #e6f7ff;\n  --bg-active-tab: #ffffff;\n  --bg-inactive-tab: rgba(255, 255, 255, 0.3);\n  --bg-surface: #ffffff;\n  \n  /* ===== TEXT COLORS ===== */\n  --text-primary: #333333;\n  --text-secondary: #666666;\n  --text-tertiary: #8c8c8c;\n  --text-hint: #999999;\n  --text-white: #ffffff;\n  --text-on-primary: #ffffff;\n  \n  /* ===== SEMANTIC COLORS ===== */\n  --success: #52c41a;\n  --error: #f5222d;\n  --warning: #faad14;\n  --info: #1890ff;\n  \n  /* ===== BORDERS & DIVIDERS ===== */\n  --border-light: #f0f0f0;\n  --border-medium: #dddddd;\n  --border-dark: #cccccc;\n  --border-primary: var(--brand-navy);\n  \n  /* ===== CHART COLORS (Blue Variations) ===== */\n  --chart-primary: #2196F3;\n  --chart-secondary: #64B5F6;\n  --chart-tertiary: #90CAF9;\n  --chart-quaternary: #BBDEFB;\n  \n  /* ===== WORKFLOW NODE COLORS (Keep existing palette) ===== */\n  --node-start: #4CAF50;\n  --node-ingestion: #2196F3;\n  --node-business-rules: #9C27B0;\n  --node-processing: #FF5722;\n  --node-decision: #795548;\n  --node-human-review: #607D8B;\n  --node-output: #E91E63;\n  --node-outbound: #00BCD4;\n  --node-abort: #F44336;\n  --node-completion: #4CAF50;\n  --node-mcp: #FF7043;\n  \n  /* ===== ANNOTATION COLORS (Keep existing rainbow palette) ===== */\n  --annotation-1: #FFEB3B;\n  --annotation-2: #66FF00;\n  --annotation-3: #FF9800;\n  --annotation-4: #2196F3;\n  --annotation-5: #F44336;\n  --annotation-6: #8E44AD;\n  --annotation-7: #795548;\n  --annotation-8: #009688;\n  --annotation-9: #FF5722;\n  --annotation-10: #607D8B;\n  --annotation-11: #E91E63;\n  --annotation-12: #3F51B5;\n  --annotation-13: #CDDC39;\n  --annotation-14: #FFC107;\n  --annotation-15: #00BCD4;\n  --annotation-16: #9C27B0;\n  \n  /* ===== SHADOWS ===== */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.15);\n  \n  /* ===== TYPOGRAPHY ===== */\n  --font-header: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;\n  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  \n  /* Font Sizes (QHD @ 125% scaling) */\n  --font-size-base: 16px;\n  --font-size-header-title: 22px;\n  --font-size-header-user: 14px;\n  --font-size-tab-title: 20px;\n  --font-size-tile-name: 15px;\n  --font-size-tile-description: 13px;\n  --font-size-icon-label: 13px;\n  --font-size-login-title: 20px;\n  --font-size-input-label: 13px;\n  --font-size-button: 14px;\n  --font-size-section-header: 12px;\n  --font-size-sidebar-nav: 16px;\n  \n  /* Font Weights */\n  --font-weight-light: 300;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  \n  /* ===== SPACING ===== */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-xxl: 48px;\n  \n  /* ===== BORDER RADIUS ===== */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  \n  /* ===== Z-INDEX ===== */\n  --z-sidebar: 10;\n  --z-header: 100;\n  --z-modal: 1000;\n  --z-tooltip: 1100;\n}\n\n/* ============================================================================\n   BASE STYLES\n   ============================================================================ */\n\nhtml {\n  font-size: var(--font-size-base);\n}\n\nbody {\n  font-family: var(--font-body);\n  color: var(--text-primary);\n  background-color: var(--bg-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ============================================================================\n   TYPOGRAPHY\n   ============================================================================ */\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-header);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-primary);\n  margin: 0;\n}\n\n/* ============================================================================\n   SIDEBAR GRADIENT\n   ============================================================================ */\n\n.sidebar-gradient {\n  background: linear-gradient(180deg, var(--sidebar-bg-start) 0%, var(--sidebar-bg-end) 100%);\n}\n\n/* ============================================================================\n   ANT DESIGN COMPONENT OVERRIDES\n   ============================================================================ */\n\n/* Buttons - Default Primary (Navy Blue) */\n.ant-btn-primary {\n  background-color: var(--brand-navy);\n  border-color: var(--brand-navy);\n  color: var(--text-white);\n}\n\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  background-color: #1a2d5a;\n  border-color: #1a2d5a;\n  color: var(--text-white);\n}\n\n/* Action Buttons (Green - for primary actions like Submit, Save, Confirm) */\n.action-button,\n.ant-btn.action-button {\n  background-color: var(--primary-accent) !important;\n  border-color: var(--primary-accent) !important;\n  color: var(--text-white) !important;\n  font-family: var(--font-body) !important;\n  font-weight: var(--font-weight-semibold) !important;\n}\n\n.action-button:hover,\n.action-button:focus,\n.ant-btn.action-button:hover,\n.ant-btn.action-button:focus {\n  background-color: #7a8f5d !important;\n  border-color: #7a8f5d !important;\n  color: var(--text-white) !important;\n}\n\n.action-button:active,\n.ant-btn.action-button:active {\n  background-color: #6a7f4d !important;\n  border-color: #6a7f4d !important;\n}\n\n/* Regular Buttons (Navy Blue - for navigation, secondary actions) */\n.regular-button,\n.ant-btn.regular-button {\n  background-color: var(--brand-navy) !important;\n  border-color: var(--brand-navy) !important;\n  color: var(--text-white) !important;\n  font-family: var(--font-body) !important;\n  font-weight: var(--font-weight-semibold) !important;\n}\n\n.regular-button:hover,\n.regular-button:focus,\n.ant-btn.regular-button:hover,\n.ant-btn.regular-button:focus {\n  background-color: #1a2d5a !important;\n  border-color: #1a2d5a !important;\n  color: var(--text-white) !important;\n}\n\n.regular-button:active,\n.ant-btn.regular-button:active {\n  background-color: #0f1a35 !important;\n  border-color: #0f1a35 !important;\n}\n\n/* Inputs */\n.ant-input:focus,\n.ant-input-focused {\n  border-color: var(--primary-accent) !important;\n  box-shadow: 0 0 0 2px rgba(146, 163, 114, 0.2) !important;\n}\n\n/* Select */\n.ant-select-focused .ant-select-selector,\n.ant-select-selector:focus,\n.ant-select-selector:active,\n.ant-select-open .ant-select-selector {\n  border-color: var(--primary-accent) !important;\n  box-shadow: 0 0 0 2px rgba(146, 163, 114, 0.2) !important;\n}\n\n/* Radio */\n.ant-radio-checked .ant-radio-inner {\n  border-color: var(--primary-accent);\n  background-color: var(--primary-accent);\n}\n\n.ant-radio:hover .ant-radio-inner {\n  border-color: var(--primary-accent);\n}\n\n/* Checkbox */\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--primary-accent);\n  border-color: var(--primary-accent);\n}\n\n.ant-checkbox:hover .ant-checkbox-inner {\n  border-color: var(--primary-accent);\n}\n\n/* Progress */\n.ant-progress-bg {\n  background-color: var(--primary-accent) !important;\n}\n\n.ant-progress-success-bg {\n  background-color: var(--success) !important;\n}\n\n.ant-progress-text {\n  color: var(--primary-accent) !important;\n}\n\n/* Spin/Loading */\n.ant-spin-dot-item {\n  background-color: var(--primary-accent);\n}\n\n/* Tabs */\n.ant-tabs-tab:not(.ant-tabs-tab-active) {\n  background-color: var(--bg-inactive-tab);\n}\n\n.ant-tabs-tab.ant-tabs-tab-active {\n  background-color: var(--bg-active-tab);\n}\n\n/* Table */\n.ant-table-thead > tr > th {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n.ant-table-tbody > tr:hover > td {\n  background-color: var(--bg-hover) !important;\n}\n\n/* Table Scrollbar */\n.ant-table-tbody {\n  scrollbar-width: thin;\n  scrollbar-color: var(--primary-accent) var(--border-light);\n}\n\n.ant-table-tbody::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ant-table-tbody::-webkit-scrollbar-track {\n  background: var(--border-light);\n}\n\n.ant-table-tbody::-webkit-scrollbar-thumb {\n  background: var(--primary-accent);\n  border-radius: 3px;\n}\n\n.ant-table-tbody::-webkit-scrollbar-thumb:hover {\n  background: #7a8f5d;\n}\n\n/* Modal */\n.ant-modal-header {\n  border-bottom: 1px solid var(--border-light);\n}\n\n.ant-modal-title {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* Card */\n.ant-card-head {\n  border-bottom: 1px solid var(--border-light);\n}\n\n.ant-card-head-title {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* Tag */\n.ant-tag {\n  border-radius: var(--radius-sm);\n}\n\n/* Alert */\n.ant-alert-info {\n  border: 1px solid #d6f7ff;\n  background-color: #f0f8ff;\n}\n\n.ant-alert-info .ant-alert-icon {\n  color: var(--info);\n}\n\n/* Tooltip */\n.ant-tooltip-inner {\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.ant-tooltip-arrow-content {\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n/* Upload */\n.ant-upload-drag .ant-upload-drag-icon {\n  margin-bottom: var(--spacing-md);\n}\n\n.ant-upload-drag .ant-upload-text {\n  font-size: var(--font-size-sidebar-nav);\n  color: var(--text-secondary);\n}\n\n.ant-upload-drag .ant-upload-hint {\n  color: var(--text-hint);\n}\n\n/* Steps */\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #d4e7f0 !important;\n  border-color: var(--brand-navy) !important;\n}\n\n.ant-steps-item-finish .ant-steps-icon {\n  color: var(--brand-navy) !important;\n}\n\n.ant-steps-item-process .ant-steps-item-icon {\n  background-color: var(--brand-navy) !important;\n  border-color: var(--brand-navy) !important;\n}\n\n.ant-steps-item-process .ant-steps-icon {\n  color: white !important;\n}\n\n.ant-steps-item-finish .ant-steps-item-tail::after {\n  background-color: var(--brand-navy) !important;\n}\n\n.ant-steps-item-title {\n  font-size: var(--font-size-sidebar-nav) !important;\n  font-weight: var(--font-weight-semibold) !important;\n}\n\n/* ============================================================================\n   CUSTOM COMPONENT STYLES\n   ============================================================================ */\n\n/* Header */\n.operational-header {\n  background: var(--brand-navy);\n  color: var(--text-white);\n  padding: 8px 24px 0 24px;\n  height: auto;\n}\n\n.header-title {\n  font-family: var(--font-header);\n  font-size: var(--font-size-header-title);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-white);\n}\n\n.header-user {\n  font-family: var(--font-header);\n  font-size: var(--font-size-header-user);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-white);\n}\n\n/* Tabs */\n.tab-title {\n  font-family: var(--font-body);\n  font-size: var(--font-size-tab-title);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n/* Sidebar */\n.sidebar-nav-item {\n  font-family: var(--font-body);\n  font-size: var(--font-size-sidebar-nav);\n  font-weight: var(--font-weight-medium);\n  color: var(--sidebar-text);\n}\n\n/* User Avatar */\n.user-avatar {\n  background-color: var(--bg-primary);\n  color: var(--brand-navy);\n  border: 2px solid var(--bg-primary);\n}\n\n/* Table Row Styles */\n.table-row-even {\n  background-color: var(--bg-tertiary);\n}\n\n.table-row-odd {\n  background-color: var(--bg-primary);\n}\n\n.table-row-even:hover,\n.table-row-odd:hover {\n  background-color: var(--bg-hover) !important;\n}\n\n/* Chat Message Styles */\n.chat-message-user {\n  background-color: var(--brand-navy);\n  color: var(--text-white);\n}\n\n.chat-message-assistant {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-light);\n}\n\n.chat-avatar {\n  background-color: var(--brand-navy);\n}\n\n/* Button Styles */\n.button-primary {\n  background-color: var(--primary-accent);\n  border-color: var(--primary-accent);\n  color: var(--text-white);\n  font-family: var(--font-body);\n  font-size: var(--font-size-button);\n  font-weight: var(--font-weight-semibold);\n}\n\n.button-primary:hover {\n  background-color: #7a8f5d;\n  border-color: #7a8f5d;\n}\n\n/* Section Headers */\n.section-header {\n  font-family: var(--font-body);\n  font-size: var(--font-size-section-header);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-primary);\n}\n\n/* Tile/Card Styles */\n.tile-name {\n  font-family: var(--font-body);\n  font-size: var(--font-size-tile-name);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.tile-description {\n  font-family: var(--font-body);\n  font-size: var(--font-size-tile-description);\n  font-weight: var(--font-weight-normal);\n  color: var(--text-secondary);\n}\n\n/* Icon Label */\n.icon-label {\n  font-family: var(--font-body);\n  font-size: var(--font-size-icon-label);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n/* Login Styles */\n.login-title {\n  font-family: var(--font-header);\n  font-size: var(--font-size-login-title);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-primary);\n}\n\n.input-label {\n  font-family: var(--font-body);\n  font-size: var(--font-size-input-label);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n\n\n/* ============================================================================\n   STEPS COMPONENT OVERRIDES (Brand Navy)\n   ============================================================================ */\n\n/* Finished step icon (blue dot) */\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #162349 !important;\n  border-color: #162349 !important;\n}\n\n/* Finished step icon inner dot */\n.ant-steps-item-finish .ant-steps-icon-dot {\n  background: #162349 !important;\n}\n\n/* Current/in-progress step icon */\n.ant-steps-item-process .ant-steps-item-icon {\n  background-color: #162349 !important;\n  border-color: #162349 !important;\n}\n\n/* Current step icon inner dot */\n.ant-steps-item-process .ant-steps-icon-dot {\n  background: #162349 !important;\n}\n\n/* Connecting line after finished steps */\n.ant-steps-item-finish .ant-steps-item-tail::after {\n  background-color: #162349 !important;\n}\n\n/* The vertical line on the left */\n.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #162349 !important;\n}\n\n\n/* ============================================================================\n   UTILITY CLASSES\n   ============================================================================ */\n\n.text-primary { color: var(--text-primary); }\n.text-secondary { color: var(--text-secondary); }\n.text-tertiary { color: var(--text-tertiary); }\n.text-white { color: var(--text-white); }\n\n.bg-primary { background-color: var(--bg-primary); }\n.bg-secondary { background-color: var(--bg-secondary); }\n.bg-accent { background-color: var(--primary-accent); }\n\n.border-primary { border-color: var(--border-primary); }\n.border-light { border-color: var(--border-light); }\n\n/* Spacing utilities */\n.p-xs { padding: var(--spacing-xs); }\n.p-sm { padding: var(--spacing-sm); }\n.p-md { padding: var(--spacing-md); }\n.p-lg { padding: var(--spacing-lg); }\n\n.m-xs { margin: var(--spacing-xs); }\n.m-sm { margin: var(--spacing-sm); }\n.m-md { margin: var(--spacing-md); }\n.m-lg { margin: var(--spacing-lg); }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
